interface OfferProps {
    id: number,
    title: string,
    text: string,
}

export const servicesData: OfferProps[] = [
    {
        id: 1,
        title: "Enfòmasyon sou vil yo",
        text: "Nou ofri enfòmasyon detaye sou vil yo nan peyi a. Sa ka enkli sit istorik, plaj, montay, kaskad, park nasyonal, ak lòt kote enteresan pou vizite.",
    },
    {
        id: 2,
        title: "Konsèy pou vwayaje",
        text: "Nou bay enfòmasyon sou sante, sekirite, transpò, ak kilti lokal. Sa ka enkli konsèy sou vaksinasyon, monnen, transpòtasyon lokal, elatriye. ",
    },
    {
        id: 3,
        title: "Informasyon sou kilti Ayiti",
        text: "Ayiti gen yon kilti rich ak tradisyon ki pi enteresan tankou mizik, danse, manje tradisyonèl, relijyon, ak koutim lokal, k ap ede ou konprann pi byen kilti peyi a.",
    },
];